// use jquery from wordpress. place in module if needed
window.$ = window.jQuery = jQuery;

import { lazy } from './helpers/lazyLoading';
import { buildNavigation } from './modules/buildNavigation';
import { headerVisuals } from './modules/headerVisuals';
import { handleBlog } from './modules/handleBlog';
import { fillerScroll } from './modules/fillerScroll';
import hljs from 'highlight.js';

//*******************************************************
// STRIPES
//*******************************************************

headerVisuals();

// const vantaEffect = VANTA.NET({
//    el: '#visuals',
//    mouseControls: true,
//    touchControls: true,
//    gyroControls: false,
//    minHeight: 200.0,
//    minWidth: 200.0,
//    scale: 1.0,
//    scaleMobile: 1.0,
//    color: 0xc0c0c0,
//    backgroundColor: 'transparent',
//    points: 9.0,
//    maxDistance: 28.0,
//    spacing: 13.0,
// });

// Update points on scroll
window.addEventListener('scroll', () => {
   const scrollPercent = Math.min(window.scrollY / (document.documentElement.scrollHeight - window.innerHeight), 1);
   console.log('Scroll Percent:', 9 + scrollPercent * 50);
   vantaEffect.setOptions({ points: 9 + scrollPercent * 100 });
});

//*******************************************************
// scroll filler
//*******************************************************

fillerScroll();

//*******************************************************
// lazy loading
//*******************************************************

lazy();

//*******************************************************
// NAV
//*******************************************************

buildNavigation();

//*******************************************************
// blog
//*******************************************************

handleBlog();

//*******************************************************
// highlight.js
//*******************************************************

hljs.highlightAll();
